import React, { useState } from "react";
import { formatDate } from "../../helper/Helper";

function StockHistoryRow({ key, index, item, reasonLabels, page, limit }) {
  const [expanded, setExpanded] = useState(new Set());

  const toggleExpand = (id) => {
    setExpanded((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const isExpanded = expanded.has(item.id);
  const isPositive = item.quantity > 0;

  return (
    <>
      <tr style={{ cursor: "pointer" }} onClick={() => toggleExpand(item.id)}>
        <td>
          {(page - 1) * limit + index + 1}.{" "}
          <span className="btn btn-sm btn-primary">
            <i className={`ti ti-chevron-${isExpanded ? "down" : "right"}`} />
          </span>
        </td>
        <td className="small">{formatDate(item.createdAt)}</td>
        <td>
          <code className="small">{item.sku}</code>
        </td>
        <td className="small">
          {item?.wareHouseName} ({item?.wareHouseId})
        </td>
        <td
          className={`text-end fw-semibold ${isPositive ? "text-success" : "text-danger"}`}
        >
          {isPositive ? "+" : ""}
          {item.quantity}
        </td>
        <td>
          <span className="badge bg-light text-dark">
            {reasonLabels[item.reason] || item.reason}
          </span>
        </td>
        <td className="small text-muted">
          {item.referenceType ? item.referenceType : "-"}
        </td>
      </tr>
      {isExpanded && (
        <tr>
          <td colSpan="7" className="bg-light">
            <div className="row g-3 small p-2">
              <div className="col-md-3">
                <div className="text-muted">State Transition</div>
                <div className="fw-semibold">
                  {item.fromState || "-"} → {item.toState}
                </div>
              </div>
              <div className="col-md-3">
                <div className="text-muted">Before / After (Available)</div>
                <div className="fw-semibold">
                  {item.availableBefore} → {item.availableAfter}
                </div>
              </div>
              <div className="col-md-3">
                <div className="text-muted">Before / After (On Hand)</div>
                <div className="fw-semibold">
                  {item.onHandBefore} → {item.onHandAfter}
                </div>
              </div>
              <div className="col-md-3">
                <div className="text-muted">Unit Cost</div>
                <div className="fw-semibold">
                  {item.unitCost ? `₹${Number(item.unitCost).toFixed(2)}` : "—"}
                </div>
              </div>
              {item.notes && (
                <div className="col-6 text-muted">
                  <div>Notes: {item.notes}</div>
                </div>
              )}
              <div className="col-6 text-muted">
                Batch: <code>{item.batchId || "-"}</code> · Added By:{" "}
                {item.userName || "-"}
              </div>
            </div>
          </td>
        </tr>
      )}
    </>
  );
}

export default StockHistoryRow;
